import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import { IconColor, IconFrame, IconSize } from '~/components/atoms/icon/Icon'
import ModelsIcon, { ModelIconProps } from '~/components/atoms/icon/ModelsIcon'
import InternalLink from '~/components/atoms/link/InternalLink'

export interface NavigationMainItemVar {
  id: number
  text: string
  link: string
  iconProps: ModelIconProps
  color: SpaceColor
}

interface Props {
  item: NavigationMainItemVar
}

const NavigationMainItem = ({item}: Props) => {
  return (
    <li className={styles.main__item}>
      <style jsx>{`
        li {
          border-left: 4px solid ${item.color};
        }
        li:hover {
          background-color: ${item.color};
          border-color: ${lightenColor(item.color, ColorWeight.MIDDLE)};
        }
     `}</style>
      <InternalLink link={item.link} className={styles.main__item__link}>
        <ModelsIcon {...item.iconProps} size={!!item.iconProps.image ? IconSize.MEDIUM : IconSize.SMALL}
                    frame={IconFrame.SQUARE} fillColor={item.color} bgColor={IconColor.WHITE}/>
        <span className={styles.main__item__text}>{item.text}</span>
      </InternalLink>
    </li>
  )
}

export default NavigationMainItem